import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listSupply48Data,
  saveSupply48Data,
} from '@ebalance/proto/bffuser/v1/supply_48_data_service-Supply48DataService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 48 点データ保存 mutation フック。
 * onSuccess で list query を invalidate して最新化する。
 */
export function useSaveSupply48Data(): InvalidatingMutationResultFor<
  typeof saveSupply48Data
> {
  return useInvalidatingMutation(saveSupply48Data, [
    createConnectQueryKey({
      schema: listSupply48Data,
      cardinality: 'finite',
    }),
  ])
}
